"use strict";

import lang from "vwa/lang";
import api from "vwa/api";
import dispatcher from "./../dispatcher";
import openedDetailsStore from "./../store/openedDetails";
import Toast from "vwa/components/Toast";
import {getUserId} from "./../utils/user";

export default async function getVehicleHeatmap(vehicleId, from, to) {
	
	try{
		const reportResponse = await api.get("reports", {
			carrier: vehicleId,
			from: from,
			to: to,
			type: "VehicleHeatmap",
			user: getUserId()
		});
		const details = openedDetailsStore.get(vehicleId);
		if (!details)
			return;
		const report = reportResponse.reports[0];
		dispatcher.dispatch("getVehicleHeatmap", report);
	}
	catch(error){
		if("id" in error){
			new Toast(lang.OPERATION_FAILED, "orange");
		}
		else{
			throw error;
		}
	}
}


// WEBPACK FOOTER //
// ./src/api/getVehicleHeatmap.js